import { all } from 'redux-saga/effects';

import authSaga from './auth';
import chatSaga from './chat';
import communitiesSaga from './communities';
import {
  currentCommunitySaga,
  defaultEventSettingSaga,
  documentsSaga,
  eventRepliesSaga,
  eventsSaga,
  pushNotificationSaga,
  requestsSaga,
  responsesSaga,
  tasksSaga,
  usersSaga,
} from './currentCommunity';
import { currentGroupSaga, groupUsersSaga } from './currentGroup';
import groupSaga from './groups';
import profileSaga from './profile';
import statisticsSaga from './statistics';
import subscriptionsSaga from './subscriptions';

export default function* rootSaga() {
  yield all([
    communitiesSaga(),
    profileSaga(),
    authSaga(),
    chatSaga(),
    groupSaga(),
    requestsSaga(),
    eventsSaga(),
    eventRepliesSaga(),
    responsesSaga(),
    tasksSaga(),
    documentsSaga(),
    usersSaga(),
    currentCommunitySaga(),
    currentGroupSaga(),
    groupUsersSaga(),
    subscriptionsSaga(),
    statisticsSaga(),
    pushNotificationSaga(),
    defaultEventSettingSaga(),
  ]);
}
